import React, { createContext } from "react";
export const EducationFormContext = createContext(null);
